<template>
   <div
      :class="[
         'layout',
         'layout-unit',
         `discipline-${route.params.discipline}`,
      ]"
   >
      <BreadCrumbs>
         <template v-slot:actions>
            <ClientOnly>
               <AssignAction targetType="units" :target-id="unit?.id" />

               <Btn
                  :text="{ do: 'Save', done: 'Saved', undo: 'Unsave' }"
                  class="yellow"
                  action
                  :actionActive="isSaved"
                  @handle-action="handleSaveUnit"
               >
                  <IconBookmarkFilled v-if="isSaved" />
                  <IconBookmark v-else />
               </Btn>
            </ClientOnly>
         </template>
      </BreadCrumbs>
      <div class="unit-wrapper">
         <NuxtPage />
      </div>
   </div>
</template>
<script setup lang="ts">
import toastMessages from "~/data/content/toast-messages.json";
import IconBookmark from "~/assets/images/icons/bookmark.svg?component";
import IconBookmarkFilled from "~/assets/images/icons/bookmark-filled.svg?component";

const route = useRoute();
const { unit, saveUnitToProfile } = useUnit();
const { profile, getProfileContent } = useProfile();
const { addToast } = useToast();

// COMPUTED ================
const isSaved = computed(() => {
   let found = false;
   profile?.value?.units?.length &&
      profile.value.units.forEach((item) => {
         item?.slug === unit?.value?.slug && (found = true);
      });
   return found;
});

// METHODS ================
const handleSaveUnit = async () => {
   // Snapshot intent before the API call — `saveUnitToProfile` triggers a
   // profile refresh that can flip `isSaved` before the toast is built.
   const method = isSaved.value ? "DELETE" : "POST";
   try {
      await saveUnitToProfile(route.params.slug, method);
      const toastMessage = method === "DELETE"
         ? { ...toastMessages.removeFromProfile.success }
         : { ...toastMessages.addToProfile.success };
      toastMessage.message = toastMessage.message.replace(
         /%s/,
         unit.value?.title ?? ""
      );
      addToast(toastMessage);
   } catch {
      const toastMessage = method === "DELETE"
         ? { ...toastMessages.removeFromProfile.error }
         : { ...toastMessages.addToProfile.error };
      toastMessage.message = toastMessage.message.replace(
         /%s/,
         unit.value?.title ?? ""
      );
      addToast(toastMessage);
   }
};

// LIFECYCLE ================
watchEffect(async () => {
   if (profile?.value?.units) return;
   try {
      await getProfileContent("units");
   } catch {
      // best-effort prefetch; layout still renders without this data
   }
});
</script>

<style lang="scss">
div.layout-unit {
   div.unit {
      width: 100dvw;
   }
}
</style>
